export default __webpack_public_path__ + "static/media/bazzle_v_3.fd4970f8.png";